import React from 'react';
import { motion } from 'framer-motion';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) => {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-133">
      {children}
    </motion.div>;
};
export const CTAButton = ({
  className = '',
  onClick
}: {
  className?: string;
  onClick?: () => void;
}) => {
  const handleClick = () => {
    if (window.fbq) {
      window.fbq('trackSingle', '1295313568614005', 'AddToCart', {
        content_name: 'El Método Acento Prohibido',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    window.open('https://dailyhomewellness.com/cart/48094784618740:1', '_blank');
  };
  return <button onClick={handleClick} className={`w-full md:w-auto bg-gold hover:bg-gold-light text-dark font-bold font-inter text-lg py-4 px-8 rounded-sm transition-all duration-300 animate-glow transform hover:-translate-y-1 ${className}`} data-id="element-134">
      ¡QUIERO EL MÉTODO AHORA!
    </button>;
};
export const SectionDivider = () => <div className="w-full flex justify-center py-6 md:py-12" data-id="element-135">
    <div className="w-24 h-[1px] bg-gold/30" data-id="element-136"></div>
  </div>;